<template>
  <div class="pod-settings-content">
    <v-container container--fluid grid-list-md>
       <v-row justify="space-between" align="center">
        <v-col cols="12" sm="12" md="6" v-for="(item, index) in items" :key="index">
          <v-checkbox
            v-if="item.type === 'checkbox'"
            :label="item.text"
            v-model="clientInfo[item.key]"
          ></v-checkbox>
          <v-select
            v-if="item.type === 'select'"
            :items="item.selectItems"
            v-model="clientInfo[item.key]"
            :label="item.text"
            :error="isFieldInvalid(item.key)"
            outlined
          >
          </v-select>
        </v-col>
       </v-row>
    </v-container>
  </div>
</template>

<script>
  // @group EditClient
  // Client POD Settings tab for EditClientPage
  export default {
    name: "PodSettings",
    props: {
      // Client Object
      clientInfo: Object,
    },
    data() {
      return {
        items: [
          {text: 'Require POD', key: 'ops_email', type: 'checkbox'},
          {text: 'Force POD', key: 'billing_email', type: 'checkbox'},
          {text: 'POD Form', key: 'report_eta', type: 'select', selectItems: ['Proof of Delivery']},
        ]
      }
    },
    computed: {
      invalidFields() {
        return this.$store.state.invalidFields || [];
      },
      isFieldInvalid() {
        return (fieldName) => this.invalidFields.includes(fieldName);
      }
    }
  }
</script>

<style scoped>
.pod-settings-content {}

.v-checkbox,
.v-switch {
  margin-bottom: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/PodSettings.vue